import { SxProps, Theme } from "@mui/material";

const getStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  container: {
    flexDirection: "column",
    gap: "var(--rhythm)",
    p: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      gap: 0,
      p: "var(--rhythm)",
    },
  },

  title: {
    mb: "var(--rhythm)",
  },
});

export default getStyles;
